import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'

import type { AgencyFormSchemaType } from '../agency-form.schema'

interface AgencyFormDescriptionsSectionProps {
  form: UseFormReturn<AgencyFormSchemaType>
  isDisabled?: boolean
}

export const AgencyFormDescriptionsSection = ({
  form,
  isDisabled = false,
}: AgencyFormDescriptionsSectionProps): ReactNode => (
  <>
    <FormField
      control={form.control}
      name="shortDescription"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Short Description</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Brief description shown in the agency list"
              disabled={isDisabled}
              className="agency-form-short-desc-input resize-none"
              rows={2}
              {...field}
            />
          </FormControl>
          <FormDescription>Maximum 200 characters</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
    <FormField
      control={form.control}
      name="bestFor"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Best For</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Describe who would benefit most from this agency"
              disabled={isDisabled}
              className="agency-form-best-for-input resize-none"
              rows={3}
              {...field}
            />
          </FormControl>
          <FormDescription>Help users understand if this agency is right for them</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  </>
)

AgencyFormDescriptionsSection.displayName = 'AgencyFormDescriptionsSection'
